import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { NgGlyph } from "@ng-icons/core";
import { DashboardFulfillmentFunnel } from "../../Components/FulfillmentFunnel/DashboardFulfillmentFunnel";
import { DashboardOverviewCards } from "../../Components/OverviewCards/DashboardOverviewCards";
import { DashboardPeriod } from "../../Dto/DashboardOverviewResponse";
import { DashboardEffects } from "../../State/DashboardEffects";
import { DashboardState } from "../../State/DashboardState";

@Component({
  standalone: true,
  selector: "app-home-page",
  imports: [CommonModule, DashboardFulfillmentFunnel, DashboardOverviewCards, NgGlyph],
  templateUrl: "./HomePage.html",
  styleUrl: "./HomePage.scss",
})
export class HomePage implements OnInit {
  private readonly dashboardEffects = inject(DashboardEffects);
  readonly dashboardState = inject(DashboardState);

  readonly periodOptions: { value: DashboardPeriod; label: string }[] = [
    { value: "week", label: "7 Days" },
    { value: "month", label: "30 Days" },
    { value: "quarter", label: "90 Days" },
    { value: "year", label: "1 Year" },
    { value: "ytd", label: "Year to date" },
  ];

  ngOnInit(): void {
    void this.dashboardEffects.loadOverview();
  }

  loadPeriod(period: DashboardPeriod): void {
    if (period === this.dashboardState.selectedPeriod() && this.dashboardState.overview()) {
      return;
    }

    void this.dashboardEffects.loadOverview(period);
  }

  getSelectedPeriodLabel(): string {
    return this.periodOptions.find((option) => option.value === this.dashboardState.selectedPeriod())?.label ?? "Year to date";
  }
}
